import { Button, Descriptions, Image, Result, Spin, Steps, Tooltip } from 'antd';
import React, { useEffect, useMemo, useState } from 'react';
import ticketService from '../../../services/ticketing/ticket.service';
import myinvoisTransService from '../../../services/myinvois/myinvois_trans.service';
import ContainerComponent from '../../../helpers/components/container.component';
import moment from 'moment';
import globalHelper from '../../../helpers/functions/global.helper';
import EntranceMotion from '../../../helpers/components/entrance_motion';
import { LoadingOutlined } from '@ant-design/icons';
import DynamicSvg from '../../../helpers/components/dynamic_svg';

const MyInvoisStatusLayout = ({ document_id, }) => {
    const [state, setState] = useState({
        loading : false,

        document : null,
        validation_link : null,
        park : null,
    })

    const document_status = useMemo(() => {
        return state?.document?.status;
    }, [state?.document])
    
    // Status of document
    // 1. Submitted
    // 2. Valid
    // 3. Invalid
    // 4. Cancelled
    const fetchDocument = async () => {
        setState(state => ({...state, loading : true, }));

        const documentResponse = await myinvoisTransService?.fetchSubmittedDocument(document_id);
        const { document, validation_link, park, } = documentResponse ?? {};

        setState(state => ({...state, loading : false, document, validation_link, park, }));
    }

    useEffect(() => {
        fetchDocument();
    }, [document_id, document_status])
    
    return (
        <>
            {
                state?.loading ?
                (
                    <>
                        <LoadingOutlined />
                    </>
                )
                :
                (
                    <>
                        <Result
                        {...document_status === 'Submitted' && ({
                            icon : (
                                <>
                                    <DynamicSvg image={`/cibanners/icon/paper-plane.svg`} size={60} color={'var(--main-color)'}/>
                                    {/* <LoadingOutlined style={{ color : 'var(--main-color)', }} /> */}
                                </>
                            )
                        })}
                        status={document_status === 'Valid' ? 'success' : 'error'}
                        title={document_status === 'Valid' ? "Document Submission Success" : document_status === 'Submitted' ? "Document Submission Submitted" : 'Document Submission Failed'}
                        subTitle={(
                            <>
                                {
                                    document_status === 'Valid' && (
                                        <>
                                            <div style={{ marginTop : 20, }}>
                                                <a target='_blank' href={state?.validation_link}>
                                                    <Button>Validation Link</Button>
                                                </a>
                                            </div>
                                        </>
                                    )
                                }
                                
                                <ContainerComponent top={20} span={20}>
                                    <Steps
                                    className='myinvois_validation_steps'
                                    // current={state?.myinvois_document?.validationResults?.validationSteps?.length}
                                    size='small'
                                    labelPlacement='vertical'
                                    items={(state?.myinvois_document?.validationResults?.validationSteps?.map(x => ({
                                        title : (
                                            <>
                                                <Tooltip {...x?.error && ({ title : x?.error?.innerError?.[0]?.error, })}>
                                                    <span>
                                                    {(x?.name?.replace(/^Step\d+-/, ''))}
                                                    </span>
                                                </Tooltip>
                                            </>
                                        ),
                                        status : (x?.status === 'Valid' ? 'finish' : 'error'),
                                    })))}
                                    />
                                </ContainerComponent>
                                {/* Status */}
                                <ContainerComponent top={12} span={14}>
                                    <Descriptions
                                    column={1}
                                    bordered
                                    size='small'
                                    items={[{
                                        key: '1',
                                        label: 'Receiver Name',
                                        children: (
                                            <span>{state?.document?.receiver_name}</span>
                                        ),
                                    },{
                                        key: '2',
                                        label: 'Receiver TIN',
                                        children: (
                                            <span>{state?.document?.receiver_id}</span>
                                        ),
                                    },{
                                        key: '3',
                                        label: 'Document ID',
                                        children: (
                                            <span>{state?.document?.myinvois_document_id}</span>
                                        ),
                                    },{
                                        key: '4',
                                        label: 'Issue Date Time',
                                        children: (
                                            <span>{moment(state?.document?.issue_date)?.format("YYYY-MM-DD hh:mm:ssa")}</span>
                                        ),
                                    },{
                                        key: '5',
                                        label: 'Received Date Time',
                                        children: (
                                            <span>{moment(state?.document?.receive_date)?.format("YYYY-MM-DD hh:mm:ssa")}</span>
                                        ),
                                    },{
                                        key: '6',
                                        label: 'Total Payable Amount',
                                        children: (
                                            <span>{`${state?.park?.currency?.code} ${state?.document?.amount}`}</span>
                                        ),
                                    },{
                                        key: '7',
                                        label: 'Status',
                                        children: (
                                            <span>{state?.document?.status}</span>
                                        ),
                                    }]}
                                    />
                                </ContainerComponent>
                            </>
                        )}
                        />
                    </>
                )
            }
        </>
    );
}

export default MyInvoisStatusLayout;